const DROPSHIPPING_REQUEST_PRODUCT = {
  STATUS: {
    ALLOW: 'Allow',
    DENY: 'Deny',
    PENDING: 'Pending',
  },
};

export default DROPSHIPPING_REQUEST_PRODUCT;
